import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "toolbarlayout"
};
const _hoisted_2 = {
  style: {
    "margin": "10px 0"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "height": "20px"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  style: {
    "display": "flex",
    "flex-flow": "row wrap",
    "min-height": "120px",
    "margin": "0",
    "padding": "0"
  }
};
const _hoisted_6 = {
  class: "icon-area-footer"
};
const _hoisted_7 = {
  class: "rhino-version-badge"
};
const _hoisted_8 = ["aria-expanded"];
const _hoisted_9 = {
  key: 2,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin": "100px 0"
  }
};
const _hoisted_10 = {
  key: 3
};
const _hoisted_11 = {
  key: 4,
  ref: "currentComponentDisplay"
};
const _hoisted_12 = {
  style: {
    "margin": "100px 0 20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "flex-flow": "row wrap"
  }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  style: {
    "margin": "15px 0",
    "display": "flex",
    "justify-content": "space-around"
  }
};
const _hoisted_16 = {
  key: 0,
  style: {
    "margin": "0 auto",
    "padding": "0",
    "width": "150px"
  }
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 0,
  style: {
    "text-align": "left",
    "font-size": "18px",
    "padding": "0 0 0 30px",
    "margin": "0"
  }
};
const _hoisted_20 = {
  key: 1,
  style: {
    "text-align": "left",
    "font-size": "18px",
    "padding": "0 10px",
    "margin": "0"
  }
};
const _hoisted_21 = {
  key: 0,
  class: "param-section"
};
const _hoisted_22 = {
  class: "param-section-header"
};
const _hoisted_23 = ["aria-expanded", "aria-label"];
const _hoisted_24 = {
  key: 1,
  class: "param-section"
};
const _hoisted_25 = {
  class: "param-section-header"
};
const _hoisted_26 = ["aria-expanded", "aria-label"];
const _hoisted_27 = {
  key: 2,
  style: {
    "margin": "10px auto"
  }
};
const _hoisted_28 = {
  style: {
    "display": "flex",
    "justify-content": "space-evenly"
  }
};
const _hoisted_29 = ["href"];
const _hoisted_30 = ["href"];
const _hoisted_31 = {
  key: 3,
  style: {
    "margin": "10px auto"
  }
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "justify-content": "space-evenly",
    "margin-top": "0"
  }
};
const _hoisted_33 = ["href"];
const _hoisted_34 = {
  key: 0
};
const _hoisted_35 = {
  key: 1
};
const _hoisted_36 = {
  key: 0
};
const _hoisted_37 = {
  key: 1
};
const _hoisted_38 = {
  key: 4
};
const _hoisted_39 = ["innerHTML"];
const _hoisted_40 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_alert = _resolveComponent("el-alert");
  const _component_GHSubCategory = _resolveComponent("GHSubCategory");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_row = _resolveComponent("el-row");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.topText !== '' ? (_openBlock(), _createBlock(_component_el_alert, {
    key: 0,
    type: "info",
    effect: "light",
    center: "",
    closable: false
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("i", {
      class: "el-icon-s-opportunity"
    }, null, -1)), _createElementVNode("p", null, _toDisplayString(this.topText), 1)])]),
    _: 1
  })) : _createCommentVNode("", true), JSON.stringify(_ctx.topTip) !== '{}' && _ctx.topTip.content !== '' ? (_openBlock(), _createBlock(_component_el_alert, {
    key: 1,
    style: {
      "margin": "10px 0"
    },
    title: _ctx.topTip.title,
    type: "warning",
    effect: "light",
    "close-text": "Close",
    center: "",
    "show-icon": "",
    description: _ctx.topTip.content
  }, null, 8, ["title", "description"])) : _createCommentVNode("", true)]), _ctx.diyTop !== '' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    innerHTML: _ctx.diyTop
  }, null, 8, _hoisted_4)) : _createCommentVNode("", true), JSON.stringify(_ctx.allCategories) !== '{}' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "tabs-wrapper",
    onTransitionend: _cache[2] || (_cache[2] = (...args) => _ctx.updateIconScrollbars && _ctx.updateIconScrollbars(...args))
  }, [_createVNode(_component_el_tabs, {
    stretch: "",
    type: "border-card",
    "tab-position": "top",
    modelValue: _ctx.currentTabName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.currentTabName = $event),
    onTabClick: _ctx.handleClickTab
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleCategories, category => {
      return _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
        label: category.name,
        name: category.name,
        key: category.id
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["icon-area", {
            'is-collapsed': _ctx.iconsCollapsed
          }]),
          style: _normalizeStyle(_ctx.collapsedAreaStyle)
        }, [_createVNode(_component_el_scrollbar, {
          ref_for: true,
          ref: "iconScrollbar",
          always: false
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategories[category.name].subCategories, (subCategory, sub_item) => {
            return _openBlock(), _createBlock(_component_GHSubCategory, {
              key: sub_item,
              "sub-category": subCategory,
              rows: this.rows_count,
              onClickComponent: _ctx.updateCurrentComponent
            }, null, 8, ["sub-category", "rows", "onClickComponent"]);
          }), 128))])]),
          _: 2
        }, 1536)], 6)]),
        _: 2
      }, 1032, ["label", "name"])), [[_directive_loading, _ctx.currentCategory.subCategories.length === 0]]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onTabClick"]), _ctx.focusMaskStyle ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "focus-mask",
    style: _normalizeStyle(_ctx.focusMaskStyle),
    "aria-hidden": "true"
  }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("i", {
    class: "fa fa-cube",
    "aria-hidden": "true"
  }, null, -1)), _createElementVNode("span", null, "Rhino " + _toDisplayString(_ctx.current_rhino_version), 1)]), _createElementVNode("button", {
    type: "button",
    class: "icon-area-toggle",
    "aria-expanded": !_ctx.iconsCollapsed,
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.toggleIconArea && _ctx.toggleIconArea(...args))
  }, [_createElementVNode("i", {
    class: _normalizeClass(["fa", _ctx.iconsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up']),
    "aria-hidden": "true"
  }, null, 2), _createElementVNode("span", null, _toDisplayString(_ctx.iconsCollapsed ? 'Expand' : 'Collapse'), 1)], 8, _hoisted_8)])], 32)) : _createCommentVNode("", true), !_ctx.currentComponent.name ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
    type: "success",
    size: "large",
    onClick: _ctx.startGuide,
    style: {
      "font-size": "18px",
      "background-color": "#86BF16",
      "border-color": "#86BF16",
      "transition": "all 0.3s ease",
      "&": "hover { background-color: #84c058",
      "color": "#ffffff"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "el-icon-guide",
      style: {
        "margin-right": "5px"
      }
    }), _cache[7] || (_cache[7] = _createTextVNode(" Start Guide "))]),
    _: 1,
    __: [7]
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _ctx.isCompLoading ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_divider), _createVNode(_component_el_skeleton, {
    rows: 10,
    style: {
      "text-align": "left",
      "margin-top": "40px"
    }
  })])) : _createCommentVNode("", true), !_ctx.isCompLoading && _ctx.currentComponent.name !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_ctx.currentComponent.icon ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "title-icon",
    src: _ctx.currentComponent.icon,
    alt: ""
  }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("h2", null, _toDisplayString(_ctx.currentComponent.name), 1), _ctx.currentComponent.sub_name !== null ? (_openBlock(), _createElementBlock("h2", _hoisted_14, [_cache[8] || (_cache[8] = _createElementVNode("span", {
    style: {
      "color": "#84c058",
      "font-weight": "200"
    }
  }, " / ", -1)), _createTextVNode(_toDisplayString(_ctx.currentComponent.sub_name), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_breadcrumb, {
    "separator-class": "el-icon-arrow-right",
    class: "elbreadcrumb"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
      to: `${this.thisAppPath}/${_ctx.currentComponent.category_name}`
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "el-icon-position",
        size: 16,
        color: "#b1b3b8"
      }), _createTextVNode(" " + _toDisplayString(_ctx.currentComponent.category_name), 1)]),
      _: 1
    }, 8, ["to"]), _createVNode(_component_el_breadcrumb_item, {
      to: `${this.thisAppPath}/${_ctx.currentComponent.category_name}/${_ctx.currentComponent.name_in_url}`
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.currentComponent.sub_category_name), 1)]),
      _: 1
    }, 8, ["to"])]),
    _: 1
  })]), _createVNode(_component_el_descriptions, {
    column: 1,
    border: "",
    class: "descriptions"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "center",
      span: "1",
      "label-class-name": "currentlabel"
    }, {
      label: _withCtx(() => [_ctx.currentComponent.top_content !== null && _ctx.currentComponent.top_content !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", {
        class: "image-container",
        innerHTML: _ctx.currentComponent.top_content
      }, null, 8, _hoisted_17)])) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "ghicon",
        src: _ctx.currentComponent.icon,
        alt: ""
      }, null, 8, _hoisted_18))]),
      default: _withCtx(() => [_ctx.descriptionLines.length > 1 ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionLines, (line, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          style: {
            "margin": "0"
          }
        }, _toDisplayString(line), 1);
      }), 128))])) : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.currentComponent.description), 1))]),
      _: 1
    })]),
    _: 1
  }), _ctx.currentComponent.input_params && _ctx.currentComponent.input_params.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_cache[9] || (_cache[9] = _createElementVNode("h3", null, "Input parameters", -1)), _ctx.canCollapseInput ? (_openBlock(), _createBlock(_component_el_tooltip, {
    key: 0,
    content: _ctx.inputTableCollapsed ? 'Show parameters' : 'Hide parameters',
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("button", {
      type: "button",
      class: "param-toggle",
      "aria-expanded": !_ctx.inputTableCollapsed,
      "aria-label": _ctx.inputTableCollapsed ? 'Show input parameters table' : 'Hide input parameters table',
      onClick: _cache[3] || (_cache[3] = $event => _ctx.inputTableCollapsed = !_ctx.inputTableCollapsed)
    }, [_createElementVNode("i", {
      class: _normalizeClass(["fa", _ctx.inputTableCollapsed ? 'fa-eye' : 'fa-eye-slash']),
      "aria-hidden": "true"
    }, null, 2)], 8, _hoisted_23)]),
    _: 1
  }, 8, ["content"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: _normalizeClass(["param-table", {
      'is-collapsed': _ctx.inputTableCollapsed && _ctx.canCollapseInput
    }])
  }, [_createVNode(_component_el_table, {
    data: _ctx.currentComponent.input_params,
    stripe: "",
    class: "full-width-table",
    "header-cell-style": _ctx.headerCellStyle,
    "cell-style": _ctx.cellStyle
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      fixed: "",
      prop: "nickname",
      label: "Nick Name",
      align: "center",
      width: "100"
    }), _createVNode(_component_el_table_column, {
      prop: "name",
      label: "Full Name",
      align: "center",
      width: "150"
    }), _createVNode(_component_el_table_column, {
      prop: "param_type",
      label: "Param Type",
      align: "center",
      width: "180"
    }), _createVNode(_component_el_table_column, {
      prop: "description",
      label: "Description",
      align: "left",
      "min-width": "150",
      "header-align": "left",
      "show-overflow-tooltip": true
    })]),
    _: 1
  }, 8, ["data", "header-cell-style", "cell-style"])], 2)])) : _createCommentVNode("", true), _ctx.currentComponent.output_params && _ctx.currentComponent.output_params.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[10] || (_cache[10] = _createElementVNode("h3", null, "Output parameters", -1)), _ctx.canCollapseOutput ? (_openBlock(), _createBlock(_component_el_tooltip, {
    key: 0,
    content: _ctx.outputTableCollapsed ? 'Show parameters' : 'Hide parameters',
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("button", {
      type: "button",
      class: "param-toggle",
      "aria-expanded": !_ctx.outputTableCollapsed,
      "aria-label": _ctx.outputTableCollapsed ? 'Show output parameters table' : 'Hide output parameters table',
      onClick: _cache[4] || (_cache[4] = $event => _ctx.outputTableCollapsed = !_ctx.outputTableCollapsed)
    }, [_createElementVNode("i", {
      class: _normalizeClass(["fa", _ctx.outputTableCollapsed ? 'fa-eye' : 'fa-eye-slash']),
      "aria-hidden": "true"
    }, null, 2)], 8, _hoisted_26)]),
    _: 1
  }, 8, ["content"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: _normalizeClass(["param-table", {
      'is-collapsed': _ctx.outputTableCollapsed && _ctx.canCollapseOutput
    }])
  }, [_createVNode(_component_el_table, {
    data: _ctx.currentComponent.output_params,
    stripe: "",
    class: "full-width-table",
    "header-cell-style": _ctx.headerCellStyle,
    "cell-style": _ctx.cellStyle
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      fixed: "",
      prop: "nickname",
      label: "Nick Name",
      align: "center",
      width: "100"
    }), _createVNode(_component_el_table_column, {
      prop: "name",
      label: "Full Name",
      align: "center",
      width: "150"
    }), _createVNode(_component_el_table_column, {
      prop: "param_type",
      label: "Param Type",
      align: "center",
      width: "180"
    }), _createVNode(_component_el_table_column, {
      prop: "description",
      label: "Description",
      align: "left",
      "min-width": "150",
      "header-align": "left",
      "show-overflow-tooltip": true
    })]),
    _: 1
  }, 8, ["data", "header-cell-style", "cell-style"])], 2)])) : _createCommentVNode("", true), _ctx.currentComponent.foreign_url1 != null && _ctx.currentComponent.foreign_url1 !== '' || _ctx.currentComponent.foreign_url2 != null && _ctx.currentComponent.foreign_url2 !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_divider, {
    style: {
      "background": "radial-gradient(circle, #c5c5c5, rgba(255, 255, 255, 0.22))",
      "width": "300px",
      "margin": "50px auto"
    }
  }), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_row, {
    style: {
      "justify-content": "center",
      "flex-direction": "column",
      "align-items": "stretch"
    }
  }, {
    default: _withCtx(() => [_ctx.currentComponent.foreign_url1 != null && _ctx.currentComponent.foreign_url1 !== '' ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: _ctx.currentComponent.foreign_url1,
      target: "_blank"
    }, [_createVNode(_component_el_button, {
      type: "success",
      style: {
        "width": "100%",
        "height": "60px",
        "font-size": "20px",
        "margin": "10px 0"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "el-icon-video-play",
        style: {
          "font-size": "20px"
        }
      }), _cache[11] || (_cache[11] = _createTextVNode(" Watch Video "))]),
      _: 1,
      __: [11]
    })], 8, _hoisted_29)) : _createCommentVNode("", true), _ctx.currentComponent.foreign_url2 != null && _ctx.currentComponent.foreign_url2 !== '' ? (_openBlock(), _createElementBlock("a", {
      key: 1,
      href: _ctx.currentComponent.foreign_url2,
      target: "_blank"
    }, [_createVNode(_component_el_button, {
      type: "success",
      style: {
        "width": "100%",
        "height": "60px",
        "font-size": "20px",
        "margin": "10px 0"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "el-icon-video-play",
        style: {
          "font-size": "20px"
        }
      }), _cache[12] || (_cache[12] = _createTextVNode(" Watch Free Video "))]),
      _: 1,
      __: [12]
    })], 8, _hoisted_30)) : _createCommentVNode("", true)]),
    _: 1
  })]), _cache[13] || (_cache[13] = _createElementVNode("div", {
    style: {
      "display": "flex",
      "justify-content": "center",
      "margin": "10px"
    }
  }, [_createElementVNode("div", {
    class: "buy-tip"
  }, [_createElementVNode("p", null, "Reminder:"), _createElementVNode("ul", null, [_createElementVNode("li", null, "Please ensure you have logged in to the online classroom and purchased this course to watch the above videos."), _createElementVNode("li", null, [_createTextVNode("You can "), _createElementVNode("a", {
    href: "https://www.bilibili.com/video/BV1tR4y1E76N/?vd_source=41eadb59acfc971596dcfbd8cf57696d",
    target: "_blank"
  }, "click here"), _createTextVNode(" to watch free tutorials to evaluate if this course meets your needs.")]), _createElementVNode("li", null, [_createTextVNode("To purchase the complete course, please "), _createElementVNode("a", {
    href: "https://rxw.h5.xeknow.com/s/1fa9Bg",
    target: "_blank"
  }, "click here"), _createTextVNode(".")])])])], -1))])) : _createCommentVNode("", true), _ctx.currentComponent.foreign_urls && _ctx.currentComponent.foreign_urls.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_divider, {
    style: {
      "background": "radial-gradient(circle, #c5c5c5, rgba(255, 255, 255, 0.22))",
      "width": "300px",
      "margin": "50px auto"
    }
  }), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_row, {
    style: {
      "justify-content": "center",
      "flex-direction": "column",
      "align-items": "stretch"
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentComponent.foreign_urls, (url_json, url_i) => {
      return _openBlock(), _createElementBlock("a", {
        href: url_json.url,
        key: url_i,
        target: "_blank"
      }, [url_json.button !== undefined && url_json.button !== '' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: url_json.button,
        plain: url_json.plain,
        style: {
          "width": "100%",
          "height": "60px",
          "font-size": "20px",
          "margin": "10px 0"
        }
      }, {
        default: _withCtx(() => [url_json.icon !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_34, [_createVNode(_component_el_icon, {
          class: _normalizeClass(url_json.icon),
          style: {
            "font-size": "20px"
          }
        }, null, 8, ["class"]), _createTextVNode(" " + _toDisplayString(url_json.text), 1)])) : _createCommentVNode("", true), url_json.icon === '' ? (_openBlock(), _createElementBlock("span", _hoisted_35, [_createVNode(_component_el_icon, {
          class: "el-icon-video-play",
          style: {
            "font-size": "20px"
          }
        }), _createTextVNode(" " + _toDisplayString(url_json.text), 1)])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["type", "plain"])) : _createCommentVNode("", true), url_json.button === undefined || url_json.button === '' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "success",
        plain: url_json.plain,
        style: {
          "width": "100%",
          "height": "60px",
          "font-size": "20px",
          "margin": "10px 0"
        }
      }, {
        default: _withCtx(() => [url_json.icon !== undefined && url_json.icon !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_36, [_createVNode(_component_el_icon, {
          class: _normalizeClass(url_json.icon),
          style: {
            "font-size": "20px"
          }
        }, null, 8, ["class"]), _createTextVNode(" " + _toDisplayString(url_json.text), 1)])) : _createCommentVNode("", true), url_json.icon === undefined || url_json.icon === '' ? (_openBlock(), _createElementBlock("span", _hoisted_37, [_createVNode(_component_el_icon, {
          class: "el-icon-video-play",
          style: {
            "font-size": "20px"
          }
        }), _createTextVNode(" " + _toDisplayString(url_json.text), 1)])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["plain"])) : _createCommentVNode("", true)], 8, _hoisted_33);
    }), 128))]),
    _: 1
  })]), _cache[14] || (_cache[14] = _createElementVNode("div", {
    style: {
      "display": "flex",
      "justify-content": "center",
      "margin": "10px"
    }
  }, [_createElementVNode("div", {
    class: "buy-tip"
  }, [_createElementVNode("p", null, "Reminder:"), _createElementVNode("ul", null, [_createElementVNode("li", null, "Please ensure you have logged in to the online classroom and purchased this course to watch the above videos."), _createElementVNode("li", null, [_createTextVNode("You can "), _createElementVNode("a", {
    href: "https://www.bilibili.com/video/BV1tR4y1E76N/?vd_source=41eadb59acfc971596dcfbd8cf57696d",
    target: "_blank"
  }, "click here"), _createTextVNode(" to watch free tutorials to evaluate if this course meets your needs.")]), _createElementVNode("li", null, [_createTextVNode("To purchase the complete course, please "), _createElementVNode("a", {
    href: "https://rxw.h5.xeknow.com/s/1fa9Bg",
    target: "_blank"
  }, "click here"), _createTextVNode(".")])])])], -1))])) : _createCommentVNode("", true), _ctx.currentComponent.bottom_content !== null && _ctx.currentComponent.bottom_content !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_el_divider, {
    style: {
      "margin": "50px auto",
      "background-color": "#dcdcdc",
      "max-width": "1200px"
    }
  }), _createElementVNode("div", {
    class: "text-container",
    style: {
      "max-width": "1200px",
      "margin": "0 auto"
    },
    innerHTML: _ctx.currentComponent.bottom_content
  }, null, 8, _hoisted_39)])) : _createCommentVNode("", true)], 512)) : _createCommentVNode("", true), _ctx.diyBottom !== '' ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    innerHTML: _ctx.diyBottom
  }, null, 8, _hoisted_40)) : _createCommentVNode("", true)]);
}